export var UserFunctionInclude = {
    businessUnits: { where: { deleted: false } },
    users: { where: { deleted: false } },
};
//# sourceMappingURL=UserFunction.js.map